import { Input } from '@patrianna/core-components'
import { useCopyClipboard } from '@patrianna/shared-hooks'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import Button from 'components/Button'
import content from 'prismic-translates/common.json'

import classes from './styles.module.scss'

type Props = {
  inputText: string
}

export default function CopyToClipboardInput(props: Props) {
  const [isCopied, setClipboard] = useCopyClipboard(props.inputText)
  const t = getTranslationFromJson([content])

  return (
    <div className={classes.root}>
      <Input
        variant='underlined'
        className={classes.input}
        defaultValue={props.inputText}
        data-test='invite-friends-copy-link'
      />

      <Button
        onClick={setClipboard}
        variant='contained'
        size='small'
        className={classes.button}
        data-test='invite-friends-copy-link-button'
      >
        {isCopied ? `✓ ${t('copied')}` : t('copy')}
      </Button>
    </div>
  )
}
